export const setAgentIds = (AgentIds) => {
    return {
      type: "SET_AGENT_IDS",
      payload: AgentIds, 
    };
  };
  
  export const setAgentPresences = (presences) => {
    return {
      type: "SET_AGENT_PRESENCES",
      payload: presences, 
    };
  };
  export const setSupervisedAgentIds = (supervisedAgentIds) => ({
    type: "SET_SUPERVISED_AGENT_IDS",
    payload: supervisedAgentIds,
  });

  export const setSupervisedAgentDetails = (supervisedAgentData) => ({
    type: "SET_SUPERVISED_AGENT_DATA",
    payload: supervisedAgentData,
  });